import React from "react"

import {
    sourceTypes,
    publicationTypes,
    contentTypeLabels,
    sourceCountries,
    sourceCountryToRegion,
    regionToParentRegion,
    licenseOptions,
    sourceLanguages,
    autopilotOptions,
} from "../../../../config/application-definitions"

const SourceEditItemClassificationDetails = ({
    type,
    lastImportTime,
    preserveArticleLinks,
    publicationType,
    contentType,
    country,
    language,
    license,
    autoApproved,
    onEventChange,
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-source" />
                Source type
            </h3>
            <select
                name="type"
                value={type}
                className="form-control"
                onChange={onEventChange}
            >
                <option selected={true} disabled="disabled" value="">
                    Please select a type
                </option>
                {sourceTypes.map((sourceType) => (
                    <option key={sourceType} value={sourceType}>
                        {sourceType}
                    </option>
                ))}
            </select>
            <h3>
                <i className="icon icon-article" />
                Last import
            </h3>
            <p>
                {lastImportTime
                    ? lastImportTime.local().format("llll")
                    : "Unknown"}
            </p>
            <h3>
                <i className="icon icon-article" />
                Preserve article links
            </h3>
            <label>
                <input
                    type="checkbox"
                    name="preserve_article_links"
                    checked={preserveArticleLinks}
                    onChange={onEventChange}
                />{" "}
                Don't alter url from the source
                {preserveArticleLinks && (
                    <p
                        style={{
                            color: "red",
                            marginTop: "5px",
                            marginBottom: "0px",
                        }}
                    >
                        Only enable this setting if the link in scraped articles
                        is not set correctly
                    </p>
                )}
            </label>
            <h3>
                <i className="icon icon-license" />
                Publication type
            </h3>
            <select
                name="publication_type"
                value={publicationType}
                className="form-control"
                onChange={onEventChange}
            >
                {publicationTypes.map((publicationTypeOption) => (
                    <option
                        key={publicationTypeOption}
                        value={publicationTypeOption}
                    >
                        {publicationTypeOption}
                    </option>
                ))}
            </select>
            <h3>
                <i className="icon icon-article" />
                Content type
            </h3>
            <select
                name="content_type"
                value={contentType}
                className="form-control"
                onChange={onEventChange}
            >
                {Object.keys(contentTypeLabels).map((value) => (
                    <option value={value} key={value}>
                        {contentTypeLabels[value]}
                    </option>
                ))}
            </select>
            <h3>
                <i className="icon icon-source" />
                Country
            </h3>
            <select
                name="country"
                value={country || ""}
                className="form-control"
                onChange={onEventChange}
            >
                <option value="" disabled={true}>
                    Please select a country
                </option>
                {sourceCountries.map((countryOption) => (
                    <option key={countryOption} value={countryOption}>
                        {countryOption}
                    </option>
                ))}
            </select>
            <h3>
                <i className="icon icon-source" />
                Region
            </h3>
            <input
                type="text"
                name="region"
                value={sourceCountryToRegion[country] || "No region"}
                className="form-control"
                onChange={onEventChange}
                disabled={true}
            />
            <h3>
                <i className="icon icon-source" />
                Greater region
            </h3>
            <input
                type="text"
                name="region"
                value={
                    regionToParentRegion[sourceCountryToRegion[country]] ||
                    "No greater region"
                }
                className="form-control"
                onChange={onEventChange}
                disabled={true}
            />
            <h3>
                <i className="icon icon-lang" />
                Article language
            </h3>
            <select
                name="language"
                value={language}
                className="form-control"
                onChange={onEventChange}
            >
                <option value="">Use language detection</option>
                {sourceLanguages.map(({ label, id }) => (
                    <option key={id} value={id}>
                        {label}
                    </option>
                ))}
            </select>
            {language && (
                <p
                    style={{
                        color: "red",
                        marginTop: "5px",
                        marginBottom: "0px",
                    }}
                >
                    Only set the language if the article language detected by
                    the scraper for this source is consistently incorrect
                </p>
            )}
            <h3>
                <i className="icon icon-license" />
                License
            </h3>
            <select
                name="license"
                value={license}
                className="form-control"
                onChange={onEventChange}
            >
                {licenseOptions.map((licenseOption) => (
                    <option key={licenseOption} value={licenseOption}>
                        {licenseOption}
                    </option>
                ))}
            </select>
            <h3>
                <i className="icon icon-autopilot" />
                Autopilot
            </h3>
            <select
                name="auto_approved"
                value={autoApproved || "null"}
                className="form-control"
                onChange={onEventChange}
            >
                <option value={"null"}>Off</option>
                {autopilotOptions.map((autopilotOption) => (
                    <option key={autopilotOption} value={autopilotOption}>
                        {autopilotOption}
                    </option>
                ))}
            </select>
        </div>
    </div>
)

export default SourceEditItemClassificationDetails
